import React from "react"

function Question({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.125 14.875C16.125 13.8395 16.9645 13 18 13C19.0355 13 19.875 13.8395 19.875 14.875C19.875 15.5624 19.505 16.1635 18.9534 16.4899C18.478 16.7711 18 17.1977 18 17.75V19"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M18 23C18.5523 23 19 22.5523 19 22C19 21.4477 18.5523 21 18 21C17.4477 21 17 21.4477 17 22C17 22.5523 17.4477 23 18 23Z"
        fill="#003E4C"
      />
      <path
        d="M13 9.33782C14.4709 8.48697 16.1786 8 18 8C23.5228 8 28 12.4771 28 18C28 23.5228 23.5228 28 18 28C12.4771 28 8 23.5228 8 18C8 16.1786 8.48697 14.4709 9.33782 13"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
      />
    </svg>
  )
}
export default Question
